var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-popup-item"},[_c('div',{staticClass:"product-image",style:({
      backgroundImage: ("url(" + (require(("../../assets/images/home/" + (this.image) + ".jpg"))) + ")")
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }